/**
 * Backend API auth headers: prefer Bearer JWT when the shopper is signed in;
 * fall back to x-api-key for anonymous legacy web requests.
 */
export function getBackendApiKey() {
  if (typeof process === "undefined" || !process.env) {
    return "";
  }
  return (
    process.env.BACKEND_API_KEY ||
    process.env.NEXT_PUBLIC_API_KEY ||
    ""
  ).trim();
}

export function getStoredAccessToken() {
  if (typeof window === "undefined") {
    return "";
  }

  try {
    const raw = localStorage.getItem("user");
    if (!raw) {
      return "";
    }
    const user = JSON.parse(raw);
    return typeof user?.accessToken === "string" ? user.accessToken.trim() : "";
  } catch {
    return "";
  }
}

export function backendApiKeyHeaders(additionalHeaders = {}) {
  const key = getBackendApiKey();
  if (!key) {
    return { ...additionalHeaders };
  }
  return { ...additionalHeaders, "x-api-key": key };
}

/**
 * Request headers for browser calls to the Express API.
 * Signed-in users send Bearer only (no shared key in flight).
 */
export function backendRequestHeaders(additionalHeaders = {}) {
  const headers = { ...additionalHeaders };
  const token = getStoredAccessToken();

  if (token) {
    headers.Authorization = `Bearer ${token}`;
    delete headers["x-api-key"];
    return headers;
  }

  return backendApiKeyHeaders(headers);
}

/** fetch() to Express API with the same auth rules as axios (Bearer when signed in). */
export async function backendFetch(url, init = {}) {
  const plainHeaders =
    init.headers instanceof Headers
      ? Object.fromEntries(init.headers.entries())
      : { ...(init.headers || {}) };

  return fetch(url, {
    ...init,
    headers: backendRequestHeaders(plainHeaders),
  });
}
